import { getDefaultHeaders, setCsrfToken } from "./utils";

export async function comicTextUpdateContext(comicTextId, translationContext) {
  let headers = await getDefaultHeaders(true, true);
  const requestOptions = {
    method: "PATCH",
    headers: headers,
    body: JSON.stringify({ translation_context: translationContext }),
  };
  const url = `/api/comic-texts/${comicTextId}/context/`;
  try {
    const response = await fetch(url, requestOptions);
    const jsonResponse = await response.json();
    if (
      response.status === 403 &&
      jsonResponse.detail.includes("CSRF Failed")
    ) {
      await setCsrfToken();
      return await comicTextUpdateContext(comicTextId, translationContext);
    }
    return jsonResponse;
  } catch (err) {
    console.log("ERROR", err);
    return { error: err.message };
  }
}
